import React, { useEffect, useState } from "react";
import "./Home.css"; // आता स्टाइल external CSS मध्ये (किंवा inline ठेवू शकता)


const Home = () => {
  const villageName = "";
  const heroImages = [
    "/images/slider1.jpeg",
    "/images/slider2.jpeg",
    "/images/slider3.jpeg",
    "/images/slider4.jpeg",

  ];

  const [currentSlide, setCurrentSlide] = useState(0);

  useEffect(() => {
    const timer = setInterval(() => {
      setCurrentSlide((prev) => (prev + 1) % heroImages.length);
    }, 5000);
    return () => clearInterval(timer);
  }, [heroImages.length]);

  const sarpanch = {
    name: "श्री. प्रीतम सरिता सुरेश बाबनवाडे",
    photo: "/images/sarpanch.jpeg",
  };

  const upsarpanch = {
    name: "श्री. देविदास यादव उकरे",
    photo: "/images/upsarpanch.jpeg",
  };

  const members = [
    { sr: 1, name: "श्री. अतुल नत्थुजी जीवतोडे", ward: "सदस्य" },
    { sr: 2, name: "श्री. भास्कर मणिराम बानबले ", ward: "सदस्य" },
    { sr: 3, name: "श्री. अश्वजीत दौलत जनबंधू", ward: "सदस्य" },
    { sr: 4, name: "सौ. तिल्लोत्तमा संतोष शेंडे", ward: "सदस्य" },
    { sr: 5, name: "सौ. अर्चना राजेश्वर चिलबुले", ward: "सदस्य" },
    { sr: 6, name: "सौ. शामलता पुरुषोत्तम खेवले", ward: "सदस्य" },
    { sr: 7, name: "सौ. खुनिता रवींद्र तिवडे", ward: "सदस्य" },
    { sr: 8, name: "सौ. गीता कुसुमाकर लांजेवार", ward: "सदस्य" },
    { sr: 9, name: "सौ. आशा उद्धव भोयर", ward: "सदस्य" },
  ];

  const SafeImage = ({ src, alt }) => {
    const fallback = "https://via.placeholder.com/300x300/D3D3D3/666666?text=फोटो+नाही";
    const [img, setImg] = useState(src);

    return (
      <img
        src={img}
        alt={alt}
        onError={() => setImg(fallback)}
        style={{ width: "100%", height: "100%", objectFit: "cover" }}
      />
    );
  };

  return (
    <div className="home-container">
      {/* Hero Slider */}

      <div className="marquee-wrapper">
        <div className="marquee">
          ग्रामपंचायत  आवळगांव | पंचायत समिती ब्रम्हपुरी, जि. चंद्रपूर |संपर्क:- 9881245686
        </div>
      </div>
      <section className="hero">
        {heroImages.map((img, i) => (
          <div
            key={i}
            className={`hero-slide ${currentSlide === i ? "active" : ""}`}
            style={{ backgroundImage: `url(${img})` }}
          />
        ))}
        <div className="hero-overlay">
          <div className="hero-content">
            <h1>        ग्रामपंचायत "आवळगांव" आपले स्वागत आहे {villageName}</h1>
            <p>आमच्या गावाचा सर्वांगीण विकास हेच आमचे ध्येय!</p>
            <a href="/aboutus">अधिक माहिती</a>
          </div>
        </div>
      </section>
      {/* Marquee Line */}



      {/* Leaders & Table Section */}
      <section className="section">
        <h2 className="title">ग्रामपंचायत प्रतिनिधी</h2>
        <div className="layout">
          {/* Leaders Cards */}
          <div className="leaders">
            <div className="leader-card sarpanch-card">
              <div className="leader-img">
                <SafeImage src={sarpanch.photo} alt="सरपंच" />
              </div>
              <h3>सरपंच</h3>
              <b>{sarpanch.name}</b>
            </div>

            <div className="leader-card upsarpanch-card">
              <div className="leader-img">
                <SafeImage src={upsarpanch.photo} alt="उपसरपंच" />
              </div>
              <h3>उपसरपंच</h3>
              <b>{upsarpanch.name}</b>
            </div>
          </div>

          {/* Members Table */}
          <div className="table-container">
            <table>
              <thead>
                <tr>
                  <th>अ.क्र.</th>
                  <th>सदस्याचे नाव</th>
                  <th>पद</th>
                </tr>
              </thead>
              <tbody>
                {members.map((m) => (
                  <tr key={m.sr}>
                    <td>{m.sr}</td>
                    <td>{m.name}</td>
                    <td>{m.ward}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      </section>
      {/* ===== Village Location Section ===== */}
      <section className="map-section">
        <h2 className="map-title">📍 ग्रामपंचायत  आवळगांव – स्थान</h2>
        <p className="map-subtitle">
          ग्रामपंचायत  आवळगांव, तालुका ब्रम्हपुरी, जिल्हा चंद्रपूर
        </p>

        <div className="map-container">
          <iframe
            title="Awalgaon Location"
            src="https://www.google.com/maps?q=20.3912377,79.9472502&z=17&output=embed"
            loading="lazy"
            referrerPolicy="no-referrer-when-downgrade"
          ></iframe>
        </div>
      </section>

    </div>
  );
};

export default Home;